import fetch from '@/utils/fetch'
import {
  shop_url
} from '@/global'
const GET_MATES = `${shop_url}/shop/app/company/employee`
const WELFARE = `${shop_url}/shop/app/company/employee/welfare`
const GET_MONEY = `${shop_url}/shop/app/company/account/`
const GET_WEL_LIST = `${shop_url}/shop/app/company/welfare/list/`
const GET_WEL_DETAIL = `${shop_url}/shop/app/company/welfare/info/`
const AGREE_WELFARE = `${shop_url}/shop/app/company/welfare/agree`
const REJECT_WELFARE = `${shop_url}/shop/app/company/welfare/reject`
const BILL_LIST = `${shop_url}/shop/app/company/bill/`
/* 获取员工 */
export const getMatesByCompanyId = (data) => {
  let url = ''
  if (data.deptId != null) {
    url = `${GET_MATES}/${data.id}?deptId=${data.deptId}`
  } else {
    url = `${GET_MATES}/${data.id}`
  }
  return fetch({
    url
  })
}
/* 发福利 */
export const welfareById = (data) => {
  return fetch({
    url: WELFARE,
    method: 'post',
    data
  })
}
/* 获取公司钱包余额 */
export const getMoneyById = (id) => {
  return fetch({
    url: GET_MONEY + id
  })
}
/* 获取福利发放的账单列表 */
export const getWelfareListById = (id, page, size) => {
  return fetch({
    url: GET_WEL_LIST + id + `?page=${page}&size=${size}`
  })
}
/* 获取福利 */
export const getWelfareDetailById = (id) => {
  return fetch({
    url: GET_WEL_DETAIL + id
  })
}

export const agreeWelfare = (data) => {
  return fetch({
    url: AGREE_WELFARE,
    method: 'put',
    data
  })
}
export const rejectWelfare = (data) => {
  return fetch({
    url: REJECT_WELFARE,
    method: 'put',
    data
  })
}

export const getBillListById = (id, keyword, start, end, page, size) => {
  return fetch({
    url: BILL_LIST + id + `?keyword=${keyword}&start=${start}&end=${end}&page=${page}&size=${size}`
  })
}
/* 获取模板 */
export const postUpload = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/company/file/upload`,
    method: 'post',
    data
  })
}

export const getStaffInfo = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/company/account/phone`,
    data,
    method: 'post'
  })
}
export const staffRefund = (data) => {
  return fetch({
    url: `${shop_url}/shop/app/company/refund`,
    data,
    method: 'post'
  })
}
